import { render, staticRenderFns } from "./ArticlePopupDisplayWorkingHours.vue?vue&type=template&id=efe52154"
import script from "./ArticlePopupDisplayWorkingHours.vue?vue&type=script&lang=js"
export * from "./ArticlePopupDisplayWorkingHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports